'use strict';

import { environment } from '@quartz-iam-legacy/environments/environment';

angular.module('userRequestArrivalControllers')

.factory('userRequestArrivalService', ['$http', '$q', function ($http, $q) {

    var service = {};

    var baseUrl = environment.apiUrl + '/ID/API/UserRequest';

    service.request = {};

    service.request.getOrCreateForArrivalEvent = function (eventId) {
        return $http.post(baseUrl + '/ForArrivalEvent/' + eventId)
                    .then(function (response) {
                        return response.data;
                    });
    }

    service.request.submit = function (userAccessRequestId) {
        return $http.post(baseUrl + '/' + userAccessRequestId + '/Submit', {});
    }

    service.request.cancel = function (userAccessRequestId) {
        return $http.post(baseUrl + '/' + userAccessRequestId + '/Cancel', {});
    }

    return service;
}]);
